<template>
  <div class="container-page">
    <p class="title-inner">ТЭС стран мира</p>
    <div class="mb-16">
      <ButtonComponent
        v-permission="permissions.import"
        :disabled="importInProgress"
        mod="gradient-bg"
        @click="importExcel()"
      >
        {{ !importInProgress ? 'Загрузить из zip' : 'Загрузка...' }}
      </ButtonComponent>
    </div>
    <template v-if="isAccessAllowed">
      <div>
        <JobStatus :options="jobOptions" />
      </div>
      <TecWorldTable :nn="nn" />
    </template>
    <section>
      <ModalComponent v-model="importModal" title="Импорт файла" @close="closeModal">
        <ImportModalRedesigned @doimport="doImport" @close="closeModal" :acceptType="acceptType" />
      </ModalComponent>
    </section>
  </div>
</template>

<script>
  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';
  import ImportModalRedesigned from '@/common/components/redesigned/ImportModalRedesigned.vue';
  import Constants from '@/common/constants';
  import security from '@/common/mixins/security';

  import JobStatus from '../../../common/components/JobStatus.vue';
  import ModalComponent from '../../../components/modals/ModalComponent.vue';
  import Api from '../api/index';
  import TecWorldTable from '../components/TecWorldTable.vue';

  const PERMISSIONS = {
    view: Constants.Permissions.TecWorldView,
    import: Constants.Permissions.TecWorldImport,
  };

  export default {
    name: 'TecWorld',
    components: { JobStatus, ImportModalRedesigned, ModalComponent, ButtonComponent, TecWorldTable },
    mixins: [security],
    data() {
      return {
        acceptType: 'application/zip,application/x-zip,application/x-zip-compressed',
        route: 'tecworld',
        importInProgress: false,
        importModal: false,
        jobOptions: [
          {
            route: 'tecworld',
            name: 'TecWorldImport',
            title: 'Загрузка данных "ТЭС стран мира"',
            totalCount: 0,
            processedCount: 0,
            currentItem: '',
            percent: 0,
            status: '',
            duration: 0,
          },
        ],
        nn: 1,
      };
    },
    created() {
      this.checkPermissionAndRedirect(PERMISSIONS.view).then((isAllowed) => {
        if (!isAllowed) return;
      });
    },
    methods: {
      importExcel() {
        this.importModal = true;
      },
      doImport(file) {
        this.closeModal();
        this.importInProgress = true;
        Api.downloadFile(this.route, file)
          .then(() => {
            Constants.alert.fire('Импорт', 'Процесс импорта успешно запущен.', 'success');
            this.importInProgress = false;
          })
          .catch((error) => {
            console.log(error?.response?.data);
            Constants.alert.fire('Импорт', 'Ошибка при импорте данных.', 'error');
            this.importInProgress = false;
          });
      },
      closeModal() {
        this.importModal = false;
      },
    },
    computed: {
      permissions: () => PERMISSIONS,
    },
  };
</script>

<style lang="scss"></style>
